import {
    GENERATE_PDF,
    DOWNLOAD_PDF,
    CLOSE_SNACK_BAR,
} from '../../actionTypes/shared/apiActionTypes';

export const initialState = {
    pdfConfiguration: null,
    isPdfDownloading: false,
    isSnackbarOpen: false,
    error: null,
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GENERATE_PDF: {
            const { payload, additionalResponseParams } = action;
            return {
                ...state,
                pdfConfiguration: payload || additionalResponseParams,
                isSnackbarOpen: !!(payload || additionalResponseParams),
                isPdfDownloading: !!(payload || additionalResponseParams),
            };
        }
        case DOWNLOAD_PDF.START:
            return {
                ...state,
                isPdfDownloading: true,
                isSnackbarOpen: true,
                error: null,
            };
        case DOWNLOAD_PDF.SUCCESS:
            return {
                ...state,
                pdfConfiguration: null,
                isPdfDownloading: false,
                isSnackbarOpen: false,
                error: null,
            };
        case DOWNLOAD_PDF.ERROR:
            return {
                ...state,
                isPdfDownloading: false,
                isSnackbarOpen: false,
                error: action.error,
            };
        case CLOSE_SNACK_BAR:
            return {
                ...state,
                isSnackbarOpen: false,
            };
        default:
            return state;
    }
};

const getPDFConfiguration = state => state.pdfConfiguration;

const isPdfDownloading = state => state.isPdfDownloading;

const isSnackbarOpen = state => state.isSnackbarOpen;

export const selectors = {
    getPDFConfiguration,
    isPdfDownloading,
    isSnackbarOpen,
};
